import { render, staticRenderFns } from "./ResultadoToggle.vue?vue&type=template&id=7121bd04&scoped=true"
import script from "./ResultadoToggle.vue?vue&type=script&lang=js"
export * from "./ResultadoToggle.vue?vue&type=script&lang=js"
import style0 from "./ResultadoToggle.vue?vue&type=style&index=0&id=7121bd04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7121bd04",
  null
  
)

export default component.exports